import { mapState } from 'vuex';
import { showDeviceTips } from '@/assets/js/attendUser.js';
import Bus from '@/assets/js/bus.js';
export default {
  props: {
    osLevelmicMuted: Boolean,
    rtilCode: {
      type: [String, Number],
      default: ''
    },
    talkBackInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    liveInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    showIconArray: {
      type: Array,
      default: function () {
        return [];
      }
    },
    currentTypeShare: {
      type: String,
      default: () => {
        return '';
      }
    },
    devicesInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    cameraDevice: {
      type: Array,
      default: function () {
        return [];
      }
    },
    microphoneDevice: {
      type: Array,
      default: function () {
        return [];
      }
    },
    speakerDevice: {
      type: Array,
      default: function () {
        return [];
      }
    },
    camera: {
      type: Boolean,
      default: false
    },
    mic: {
      type: Boolean,
      default: true
    },
    isShare: {
      type: Boolean,
      default: false
    },
    showUnread: {
      type: Boolean,
      default: false
    },
    hasSetRaiseHand: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    pipsListFullScreen: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Array,
      default: () => {
        return [];
      }
    },
    showPipFullScreen: {
      type: Boolean,
      default: true
    },
    startHearSelf: {
      type: Boolean,
      default: false
    },
    localVolume: {
      type: Number,
      default: 0
    },
    rtc: {
      type: Object,
      default: () => {}
    },
    showChat: {
      type: Boolean,
      default: false
    },
    showAISpeech: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      showDeviceTips
    };
  },
  data() {
    return {
      initVideoPopup: true,
      initAudioPopup: true,
      lastDisableCamera: 0,
      lastDisableMic: 0,
      canHearSelf: false,
      isSetMirror: false,
      recordStatus: false,
      // false 没有开始录制, true 录制中
      audioSetting: false
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      isMute: state => state.isMute
    }),
    hearSelfTips() {
      let _str = '';
      if (!this.mic) {
        _str = this.$t('setting.notHearSelfTips');
      } else {
        this.canHearSelf ? _str = this.$t('setting.offAudioFeedBack') : _str = this.$t('setting.onAudioFeedBack');
      }
      return _str;
    },
    returnRecordText() {
      const str = this.recordStatus ? 'Recording...' : 'Record';
      return str;
    },
    showGroupList() {
      if (this.userInfo.owner) {
        return this.State.pushTalkOpen;
      } else {
        return this.State.pushTalkOpen && this.State.participantPushTalkOpen;
      }
    }
  },
  methods: {
    mouseDown(item, index, event) {
      event.preventDefault();
      item.key = index + 1; // 假设index是该组件对应的标识号，用于模拟键盘按键
      this.$emit('handleMouseDown', event, item);
    },
    mouseUp(item) {
      this.$emit('handleMouseUp', null, item);
    },
    changeRecord() {
      this.recordStatus = !this.recordStatus;
      this.$emit('eventCallback', {
        type: 'changeRecord',
        val: this.recordStatus
      });
    },
    lazyAudioCallback(info) {
      const {
        type
      } = info;
      if (type === 'setTalback') {
        this.setTalkback();
      }
    },
    setTalkback() {
      const params = {
        partyCode: this.userInfo.joinCode,
        module: this.talkBackInfo[this.userInfo.rtilCode] ? 'cancelParticipantTalkBack' : 'setParticipantTalkBack',
        msg: {
          rtilCode: this.userInfo.rtilCode,
          receiverId: this.liveInfo.peerId,
          initiator: this.userInfo.rtilCode
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=37589', params).then(res => {
        const {
          errorCode
        } = res.data.result;
        if (errorCode === '0x0') {
          this.talkBackInfo[this.rtilCode] ? this.$message.success(this.$t('commonSetting.rOutputToR')) : this.$message.success(this.$t('commonSetting.lOutputToR'));
        }
      });
    },
    showTalkbackTitle(haveSetTalkback) {
      let _str = '';
      const _this = this;
      haveSetTalkback ? _str = this.$t('commonSetting.offLazyAudioTips') : _str = this.$t('commonSetting.turnOnLazy');
      if (_this.liveInfo.peerId && _this.liveInfo.peerId.includes('fffff')) {
        _str = this.$t('addWords.producerNotSupport');
      }
      return _str;
    },
    showDialog() {
      this.$emit('eventCallback', {
        type: 'leave'
      });
    },
    turnTips(flag, tag) {
      // 无摄像头
      let msg = '';
      if (tag === 'camera' && !this.devicesInfo.cameraId || tag === 'microphone' && !this.devicesInfo.microphoneId) {
        msg = 'No access';
      } else {
        const onOroff = flag ? this.$t('operationBtn.off') : this.$t('operationBtn.on');
        msg = `${onOroff} ${tag}`;
      }
      return msg;
    },
    setCameraOrMic(type, val) {
      // 防止点击过快
      const currentTime = Date.now();
      if (type === 'muteVideo') {
        if (currentTime - this.lastDisableCamera < 1000) {
          if (this.initVideoPopup) {
            this.initVideoPopup = !this.initVideoPopup;
            this.$message.warning(this.$t('commonFunction.notOperateFrequery'));
          }
          return;
        } else {
          this.initVideoPopup = true;
        }
        this.lastDisableCamera = currentTime;
      }
      if (type === 'muteAudio') {
        if (currentTime - this.lastDisableMic < 1000) {
          if (this.initAudioPopup) {
            this.initAudioPopup = !this.initAudioPopup;
            this.$message.warning(this.$t('commonFunction.notOperateFrequery'));
          }
          return;
        } else {
          this.initAudioPopup = true;
        }
        this.lastDisableMic = currentTime;
      }
      this.$emit('eventCallback', {
        type,
        val
      });
    },
    updateDeviceId(type, info) {
      if (type == 'video') {
        this.devicesInfo.cameraId = info;
      } else if (type == 'audio') {
        this.devicesInfo.microphoneId = info;
      } else {
        this.devicesInfo.speakerId = info;
      }
    },
    changeDevice(info) {
      this.$emit('eventCallback', {
        type: 'changeDevice',
        val: info
      });
    },
    changeMute(val) {
      this.$emit('eventCallback', {
        type: 'changeMute',
        val
      });
    },
    shareScreen(val) {
      const {
        type
      } = val;
      this.$emit('eventCallback', {
        type: 'shareScreen',
        shareType: type
      });
    },
    showChatModule() {
      Bus.$emit('executeHideConferenceOperate');
      this.$emit('eventCallback', {
        type: 'showChat',
        val: !this.showChat
      });
    },
    showAISpeechPop() {
      this.$emit('eventCallback', {
        type: 'showAISpeechPop'
      });
    },
    showVoiceModule() {
      this.$emit('eventCallback', {
        type: 'showAISpeech',
        val: !this.showAISpeech
      });
    },
    setRaiseHand() {
      this.$emit('eventCallback', {
        type: 'raiseHand'
      });
    },
    setPublicChat() {
      this.$emit('eventCallback', {
        type: 'publicChat'
      });
    },
    fullScreenFn() {
      if (this.showChat) this.$emit('eventCallback', {
        type: 'showChat',
        val: false
      });
      this.$emit('eventCallback', {
        type: 'fullScreen'
      });
    },
    controlHearSelf(type) {
      if (!this.mic) return;
      if (type === 'closeFeature') {
        this.canHearSelf = false;
      } else {
        this.canHearSelf = true;
      }
      this.$emit('eventCallback', {
        type: 'hearSelfFeature',
        val: this.canHearSelf
      });
    },
    changeHearSelfValue(val) {
      this.canHearSelf = val;
    },
    controlAudio(val) {
      this.$emit('eventCallback', {
        type: 'muteAudio',
        val
      });
    },
    showPushTalkTips(item, index) {
      index = index < 9 ? index + 1 : 0;
      const tipText = this.$t('pushTalk.puskTalkFootTips', {
        index: `<span style="color: #909090;">[${index}]</span>`,
        groupName: item.groupName
      });
      return tipText;
    },
    showGroupName(item, index) {
      return item.groupName.replace(`group${index + 1}`, this.$t('pushTalk.pushTalk') + ' ' + this.returnIndex(index));
    },
    showGroupNumber(item) {
      const number = item.rtilCodeList.filter(rtilCode => this.State.allRtilCodeArray.includes(rtilCode)).length;
      return ' (' + number + ' ' + this.$t('pushTalk.people') + ')';
    },
    returnIndex(number) {
      if (number <= 9) {
        return `0${number + 1}`;
      } else {
        return number;
      }
    }
  }
};